export default "__VITE_ASSET__BmXBsM8x__"